/* Heroka — theme behaviour.
   Scope: announcement rotator, hero slider, product rails, mobile menu drawer,
   and the bag button (which hands off to Dawn's own cart drawer).
   The cart itself is Dawn's — we never reimplement /cart.js. */
(function () {
  'use strict';

  /* ---------- announcement rotator ---------- */
  var ann = document.querySelectorAll('.ann-rot p');
  if (ann.length > 1) {
    var ai = 0;
    setInterval(function () {
      ann[ai].classList.remove('on');
      ai = (ai + 1) % ann.length;
      ann[ai].classList.add('on');
    }, 4000);
  }

  /* ---------- hero slider ---------- */
  var track = document.getElementById('heroTrack');
  var dots = document.getElementById('heroDots');
  if (track && dots && track.children.length) {
    var n = track.children.length, cur = 0, timer;
    for (var k = 0; k < n; k++) {
      (function (k) {
        var b = document.createElement('button');
        b.setAttribute('aria-label', 'Slide ' + (k + 1));
        b.addEventListener('click', function () { go(k); });
        dots.appendChild(b);
      })(k);
    }
    function paint() {
      Array.prototype.forEach.call(dots.children, function (b, j) {
        b.setAttribute('aria-current', j === cur);
      });
    }
    function go(k) {
      cur = (k + n) % n;
      track.scrollTo({ left: track.clientWidth * cur, behavior: 'smooth' });
      paint(); reset();
    }
    function reset() {
      clearInterval(timer);
      if (n > 1) timer = setInterval(function () { go(cur + 1); }, 6000);
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-hero]'), function (b) {
      b.addEventListener('click', function () { go(cur + parseInt(b.dataset.hero, 10)); });
    });
    track.addEventListener('scroll', function () {
      var k = Math.round(track.scrollLeft / track.clientWidth);
      if (k !== cur) { cur = k; paint(); }
    }, { passive: true });
    paint(); reset();
  }

  /* ---------- product rails ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), function (b) {
    b.addEventListener('click', function () {
      var r = document.getElementById(b.dataset.rail);
      if (!r) return;
      r.scrollBy({ left: parseInt(b.dataset.dir, 10) * Math.round(r.clientWidth * 0.8), behavior: 'smooth' });
    });
  });

  /* ---------- overlay controller (mobile menu only) ---------- */
  var body = document.body, lastFocus = null;
  function closeAll() {
    body.classList.remove('open-any');
    Array.prototype.forEach.call(document.querySelectorAll('.drawer.on'), function (el) {
      el.classList.remove('on');
    });
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }
  function openPanel(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (!lastFocus) lastFocus = document.activeElement;
    body.classList.add('open-any');
    el.classList.add('on');
    var f = el.querySelector('button:not([disabled]),[href],input');
    if (f) setTimeout(function () { f.focus(); }, 90);
  }
  var openMenu = document.getElementById('openMenu');
  if (openMenu) openMenu.addEventListener('click', function () { openPanel('menuDrawer'); });
  var scrim = document.getElementById('scrim');
  if (scrim) scrim.addEventListener('click', closeAll);
  Array.prototype.forEach.call(document.querySelectorAll('[data-close]'), function (b) {
    b.addEventListener('click', closeAll);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* mobile submenu toggles */
  Array.prototype.forEach.call(document.querySelectorAll('[data-sub]'), function (b) {
    b.addEventListener('click', function () {
      var li = b.parentElement;
      li.classList.toggle('on');
      var s = b.querySelector('span');
      if (s) s.textContent = li.classList.contains('on') ? '\u2013' : '+';
    });
  });

  /* ---------- product gallery: arrows, thumbs, counter ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), function (gal) {
    var track = gal.querySelector('[data-track]');
    if (!track) return;
    var slides = track.children.length;
    if (!slides) return;
    var thumbs = gal.querySelectorAll('[data-go]');
    var counter = gal.querySelector('[data-counter]');
    var prev = gal.querySelector('.pdp-arrow.prev');
    var next = gal.querySelector('.pdp-arrow.next');
    var i = 0;

    function paint() {
      Array.prototype.forEach.call(thumbs, function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides;
      if (prev) prev.disabled = (i === 0);
      if (next) next.disabled = (i === slides - 1);
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
    function go(n) {
      i = Math.max(0, Math.min(slides - 1, n));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      paint();
    }
    Array.prototype.forEach.call(gal.querySelectorAll('.pdp-arrow'), function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.dataset.dir, 10)); });
    });
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.go, 10)); });
    });
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== i && n >= 0 && n < slides) { i = n; paint(); }
    }, { passive: true });
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });
    paint();
  });

  /* ---------- bag button → Dawn's cart drawer ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-open-cart]'), function (b) {
    b.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      /* If the store is set to "Drawer" cart type, hand off to Dawn.
         Otherwise let the link fall through to the /cart page. */
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(b);
      }
    });
  });
})();
